import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getReq, postReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/partner-commission-report"); // Partner: Get current month report data

export var getCurrentAmount = function getCurrentAmount(params) {
  return getReq("".concat(BASE_URL, "/amount"), {
    params: _objectSpread({}, (params === null || params === void 0 ? void 0 : params.partner) && {
      partner_id: params === null || params === void 0 ? void 0 : params.partner
    })
  });
}; // Partner: Submit report for current month

export var submitCommissionReport = function submitCommissionReport(data) {
  return postReq("".concat(BASE_URL, "/report"), data);
}; // Partner: Get past reports

export var getPartnerPastReports = function getPartnerPastReports(params) {
  return getReq("".concat(BASE_URL, "/history"), {
    params: _objectSpread(_objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.pageSize) && {
      per_page: params === null || params === void 0 ? void 0 : params.pageSize
    }), (params === null || params === void 0 ? void 0 : params.pageIndex) !== undefined && {
      page: (params === null || params === void 0 ? void 0 : params.pageIndex) + 1
    }), (params === null || params === void 0 ? void 0 : params.partner) && {
      partner_id: params === null || params === void 0 ? void 0 : params.partner
    })
  });
}; // Partner: Get document for a report

export var getCommissionReportPartnerDocument = function getCommissionReportPartnerDocument(reportId) {
  return getReq("".concat(BASE_URL, "/").concat(reportId, "/partner-document"), {
    responseType: 'arraybuffer'
  });
}; // Creditor: Get document for a report

export var getCommissionReportCreditorDocument = function getCommissionReportCreditorDocument(reportId) {
  return getReq("".concat(BASE_URL, "/").concat(reportId, "/creditor-document"), {
    responseType: 'arraybuffer'
  });
}; // Creditor: Get all partners pending reports

export var getAllPartnersCommissions = function getAllPartnersCommissions(params) {
  return getReq("".concat(BASE_URL, "/history"), {
    params: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.pageSize) && {
      per_page: params === null || params === void 0 ? void 0 : params.pageSize
    }), (params === null || params === void 0 ? void 0 : params.pageIndex) !== undefined && {
      page: (params === null || params === void 0 ? void 0 : params.pageIndex) + 1
    }), (params === null || params === void 0 ? void 0 : params.partner) && {
      partner_id: params === null || params === void 0 ? void 0 : params.partner
    }), (params === null || params === void 0 ? void 0 : params.month) && {
      month: params === null || params === void 0 ? void 0 : params.month
    }), (params === null || params === void 0 ? void 0 : params.year) && {
      year: params === null || params === void 0 ? void 0 : params.year
    }), (params === null || params === void 0 ? void 0 : params.status) && {
      status: params === null || params === void 0 ? void 0 : params.status
    })
  });
}; // Creditor: Accept partner's report

export var acceptCommissionReport = function acceptCommissionReport(reportId) {
  return postReq("".concat(BASE_URL, "/").concat(reportId, "/accept"));
}; // Creditor: Get all past reports (for all partners)

export var getAllPastCommissionReports = function getAllPastCommissionReports(params) {
  return getReq("".concat(BASE_URL, "/history"), {
    params: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.pageSize) && {
      per_page: params === null || params === void 0 ? void 0 : params.pageSize
    }), (params === null || params === void 0 ? void 0 : params.pageIndex) !== undefined && {
      page: (params === null || params === void 0 ? void 0 : params.pageIndex) + 1
    }), (params === null || params === void 0 ? void 0 : params.partner) && {
      partner_id: params === null || params === void 0 ? void 0 : params.partner
    }), (params === null || params === void 0 ? void 0 : params.year) && {
      year: params === null || params === void 0 ? void 0 : params.year
    })
  });
};